import { render, staticRenderFns } from "./text.vue?vue&type=template&id=1c58f4a2&scoped=true"
import script from "./text.ts?vue&type=script&lang=ts&external"
export * from "./text.ts?vue&type=script&lang=ts&external"
import style0 from "./text.less?vue&type=style&index=0&id=1c58f4a2&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c58f4a2",
  null
  
)

export default component.exports